import React from 'react';
import Popper from '@material-ui/core/Popper';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import RemoveRedEye from '@material-ui/icons/RemoveRedEye';

import { VerticalTimeline } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { ApplicationItem } from './applicationItem';
import './style.css';

export default function FutureApplications({ data, employeeId, reload }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  function handleClick(event) {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  return (
    <div>
      <Button aria-describedby={id} variant="contained" color="primary" onClick={handleClick}>
        <RemoveRedEye />&nbsp;VER APLICAÇÕES FUTURAS
      </Button>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
        transition
        style={{ zIndex: 1 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper elevation={2} style={{ width: '280px', background: '#f1f0f0' }}>
              <VerticalTimeline layout="1-column" className="vertical-timeline">
                {
                  data.map(item => <ApplicationItem id={item.id} reload={() => reload()} employeeId={employeeId} title={item.title} name={item.name} label={item.label} date={item.date} />)
                }
              </VerticalTimeline>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  );
}
